import { createApiSaga } from "redux-store/api-sagas";
import { vistarService } from "service/vistar";

import {
  LOAD_VISTAR_ACCOUNTS_SUCCESS,
  LOAD_VISTAR_ACCOUNTS_FAILURE,
  LOAD_VISTAR_ACCOUNT_NETWORKS,
  LOAD_VISTAR_VENUES,
} from "./actions";

const reloadVistarAccountsSaga = createApiSaga({
  service: vistarService.getAllVistarAccounts,
  serviceName: "vistarService.getAllVistarAccounts",
  successAction: LOAD_VISTAR_ACCOUNTS_SUCCESS,
  failureAction: LOAD_VISTAR_ACCOUNTS_FAILURE,
  reload: true,
});

const vistarAccountNetworksSaga = createApiSaga({
  service: vistarService.getVistarAccountNetworks,
  serviceName: "vistarService.getVistarAccountNetworks",
  fetchAction: LOAD_VISTAR_ACCOUNT_NETWORKS,
  reload: false,
});

const vistarAccountVenuesSaga = createApiSaga({
  service: vistarService.getVistarVenues,
  serviceName: "vistarService.getVistarVenues",
  fetchAction: LOAD_VISTAR_VENUES,
  reload: false,
});

export {
  reloadVistarAccountsSaga,
  vistarAccountNetworksSaga,
  vistarAccountVenuesSaga,
};
